// FormatPicker.tsx — widget del step 'format'.
// Qué hace: grilla de formatos (aspect ratios) con icono, label y hint.
// Qué exporta: FormatPicker.
// Quién lo usa: NovahGenerateChat.

import { PreviewFormat, SocialNetwork } from '@agency-smm/shared';
import { FORMAT_OPTIONS, suggestFormat } from '../types';
import { WidgetWrap, StyleGrid, StyleOption, StyleIcon, StyleLabel, PlanTag } from '../styled';

interface Props {
  confirmFormat: (fmt: PreviewFormat) => void;
  // Plataformas elegidas: para resaltar el formato sugerido según la red.
  selectedPlatforms?: Set<SocialNetwork>;
}

export function FormatPicker({ confirmFormat, selectedPlatforms }: Props) {
  // El formato sugerido se deriva de las redes elegidas (mismo helper que el flujo).
  const suggested = selectedPlatforms && selectedPlatforms.size > 0
    ? suggestFormat(Array.from(selectedPlatforms))
    : undefined;

  return (
    <WidgetWrap>
      <StyleGrid>
        {FORMAT_OPTIONS.map((opt) => {
          const isSuggested = opt.id === suggested;
          return (
            <StyleOption key={opt.id} $active={isSuggested} onClick={() => confirmFormat(opt.id)}>
              <StyleIcon>{opt.icon}</StyleIcon>
              <StyleLabel>{opt.label}</StyleLabel>
              <PlanTag>{isSuggested ? 'Suggested' : opt.hint}</PlanTag>
            </StyleOption>
          );
        })}
      </StyleGrid>
    </WidgetWrap>
  );
}
